import React from 'react';

const profileConfig = {
	settings: {
        style: 'layout1',
        layout: {
            config: {
                needUserInfo: true,
                redirectOn401: true,
                footer: {
                    display: true
                }
            }
        }
	},
	routes: [
		{
			path: '/profile',
			component: React.lazy(() => import('./profile'))
		}
	]
};

export default profileConfig;
